import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import { AuthGate } from "./AuthGate";
import { buildOidcConfig } from "./auth";
import { isOidcConfigured, loadRuntimeConfig } from "./config";
import "./styles/main.scss";

// Must run before buildOidcConfig() so the OIDC settings are populated from
// the runtime /config.json rather than empty Vite-env defaults.
await loadRuntimeConfig();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const tree = (
  <React.StrictMode>
    <AuthGate>
      <App />
    </AuthGate>
  </React.StrictMode>
);

// AuthProvider's settings are read once at construction; only wrap when OIDC
// is actually configured (in dev/local, the gate falls through to `children`).
root.render(isOidcConfigured() ? <AuthProvider {...buildOidcConfig()}>{tree}</AuthProvider> : tree);
